export default "__VITE_ASSET__DXGbNFsT__"